import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

// SemanticUI components 
import { Icon, CardGroup, Button, Header, Segment } from 'semantic-ui-react'

// Components
import { optionsExtraTypes } from './systemdata'
import Max2ContractSpecialsPreview from './specials_preview'

// Actions
import { doContractAction } from "./contractSlice";


/**
 * 
 * @param {bool} editMode 
 * @param {string} type 
 * @returns 
 */
const Max2ContractSpecials = ({editMode, type}) => {
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  
  // Edit mode?
  const readOnly = editMode ? false : true;

  // Extra groups
  // This is used to build the Accordion panes
  let extraGroups = [];
  
  
  if (readOnly) {
    // Group extras by ExtraType
    let groupedExtras = [];
    for (const extraKey in Contract.Extras) {
      if (Contract.Extras[extraKey].ExtraGroup !== type) {
        continue;
      }
      const extraType = Contract.Extras[extraKey].ExtraType;
      if (Object.prototype.hasOwnProperty.call(Contract.Extras, extraKey)) {
        if (!Object.prototype.hasOwnProperty.call(groupedExtras, extraType)) {
          groupedExtras[extraType] = [];
        }
        groupedExtras[extraType].push(Contract.Extras[extraKey]);
      }
    }
    
    // Build Accordion panes
    for (const extraGroupKey in groupedExtras) {
      const extraCards = groupedExtras[extraGroupKey].map((extra, index) => {
        return <Max2ContractSpecialsPreview editMode={editMode} extra={extra} />
      });
      extraGroups.push(
        <>
          <Segment secondary key={extraGroupKey}>
            <Header as='h4' dividing>{extraGroupKey}</Header>
            <CardGroup>
              {extraCards}
            </CardGroup>
          </Segment>
        </>
      );
    }

  } else {
    extraGroups = optionsExtraTypes[type].map((extraType) => {
      return (
        <Segment secondary key={extraType.text}>
          <Header as='h4' dividing>{extraType.text}</Header>
          <CardGroup>
            {Contract.Extras.filter(extra => extra.ExtraType === extraType.text && extra.ExtraGroup === type).map((extra, index) => {
              return <Max2ContractSpecialsPreview key={index} editMode={editMode} extra={extra} />
            })}
          </CardGroup>
          <br />
          <Button basic circular icon floated='right' onClick={()=>dispatch(doContractAction({target: 'Special.add', type: extraType.text, group: type}))}><Icon name='add' /></Button>
          <br />
          <br />
        </Segment>
      );
    });
  }
  





  return (
    <>
    {extraGroups}
    </>
  );
}

export default Max2ContractSpecials;
